import { Backdrop, CircularProgress, Box } from "@mui/material";

const PermissionsStatusLoader = ({ open }) => {
  return (
    <Box>
      <Backdrop className="back-drop-container" open={open}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </Box>
  );
};

export default PermissionsStatusLoader;
